function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Chat_svg__clip0)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, React.createElement("path", {
  d: "M4.5 3A1.5 1.5 0 003 4.5v24A1.5 1.5 0 004.5 30h6a1.5 1.5 0 011.5 1.5v6l3.6-2.7a1.5 1.5 0 011.8 2.4l-6 4.5A1.5 1.5 0 019 40.5V33H4.5A4.501 4.501 0 010 28.5v-24C0 2.016 2.016 0 4.5 0h33C39.984 0 42 2.016 42 4.5v9a1.5 1.5 0 01-3 0v-9A1.5 1.5 0 0037.5 3h-33z"
}), React.createElement("path", {
  d: "M9 10.5A1.5 1.5 0 0110.5 9h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 019 10.5zm0 9a1.5 1.5 0 011.5-1.5h6a1.5 1.5 0 010 3h-6A1.5 1.5 0 019 19.5zm12 0a1.5 1.5 0 011.5-1.5h24a1.5 1.5 0 011.5 1.5v18a1.5 1.5 0 01-1.5 1.5H42v7.5a1.5 1.5 0 01-2.56 1.06L30.878 39H22.5a1.5 1.5 0 01-1.5-1.5v-18zm3 1.5v15h7.5a1.5 1.5 0 011.06.44L39 42.878V37.5a1.5 1.5 0 011.5-1.5H45V21H24z"
}), React.createElement("path", {
  d: "M27 25.5a1.5 1.5 0 011.5-1.5h12a1.5 1.5 0 010 3h-12a1.5 1.5 0 01-1.5-1.5zm0 6a1.5 1.5 0 011.5-1.5h12a1.5 1.5 0 010 3h-12a1.5 1.5 0 01-1.5-1.5z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "Chat_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h48v48H0V0z"
})));

function SvgChat(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default SvgChat;